import { render, staticRenderFns } from "./CompanyModal.vue?vue&type=template&id=671f8db9&scoped=true&"
import script from "./CompanyModal.vue?vue&type=script&lang=js&"
export * from "./CompanyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671f8db9",
  null
  
)

export default component.exports